import { styled, ToggleButton, ToggleButtonProps as MuiToggleButtonProps } from '@mui/material'
import { IconSize } from './Icon'
import { Icon, IconNames } from 'hello-design-system'
import { ReactElement } from 'react'

type ToggleButtonProps = {
    id?: string
    disabled?: boolean
    onClick?: MuiToggleButtonProps['onClick']
    icon: IconNames | ReactElement
    color: MuiToggleButtonProps['color']
    children?: React.ReactNode | string
    selected?: boolean
    value?: string | number
}

const StyledButton = styled(ToggleButton)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        width: theme.spacing(5),
        height: theme.spacing(5)
    },
    '&.MuiButtonBase-root': {
        // '&.Mui-selected': {

        // },
        color: theme.palette.text.primary
    }
}))

const StandardToggleButton: React.FC<ToggleButtonProps> = ({ id, icon, color, onClick, disabled, children, selected }) => (
    <StyledButton
        id={id}
        color={color}
        onClick={onClick}
        disabled={disabled}
        value={''}
        selected={selected}>
        {typeof icon === 'string' ? <Icon iconName={icon} /> : icon}
        {children}
    </StyledButton>
)

type CommonToggleButtonProps = {
    id?: string
    active?: boolean
    size?: IconSize
    onClick?: ToggleButtonProps['onClick']
    disabled?: boolean
    children?: React.ReactNode
    selected?: boolean
}

export type { ToggleButtonProps, CommonToggleButtonProps }
export { StandardToggleButton }
